import _Vue from "vue";
import DateUtils from "@/utils/DateUtils";
import DocumentUtils from "@/utils/DocumentUtils";
import Workspaces from "@/state/Workspaces";
import Application from "@/state/Application";
import Clipboard from "@/state/Clipboard";
import StringUtils from "@/utils/StringUtils";
import Notifications from "@/state/Notifications";

/**
 * Declare types at vue-plugins.d.ts
 * */
export function UtilsVuePlugin(Vue: typeof _Vue, options?: any): void {

    Vue.prototype.$dateUtils = DateUtils
    Vue.prototype.$docUtils = DocumentUtils
    Vue.prototype.$download = DocumentUtils.download
    Vue.prototype.$stringUtils = StringUtils
    Vue.prototype.$wss = Workspaces
    Vue.prototype.$app = Application
    Vue.prototype.$clipboard = Clipboard
    Vue.prototype.$loadOn = Application.startLoading
    Vue.prototype.$loadOff = Application.stopLoading
    Vue.prototype.$nts = Notifications

}
